export default {"src":"/_next/static/image/src/assets/icons/filter-icons/sauna.557833526baac891fc5bc234e5df9bb3.svg","height":32,"width":32};